module.exports = __webpack_public_path__ + "static/media/navigate_before_white_24dp.cb57123d.svg";